
import { useToast } from '@/hooks/use-toast';
import { useTranslationUtils } from '@/hooks/useTranslationUtils';

export const useFormValidation = () => {
  const { t } = useTranslationUtils();
  const { toast } = useToast();

  const validateForm = (formValues: any) => {
    // Validate required fields
    if (!formValues.name || !formValues.start_date || !formValues.draw_date) {
      toast({
        title: t('admin.error'),
        description: t('admin.requiredFields'),
        variant: 'destructive',
      });
      return false;
    }

    // Validate dates
    const startDate = new Date(formValues.start_date);
    const drawDate = new Date(formValues.draw_date);
    
    if (drawDate <= startDate) {
      toast({
        title: t('admin.error'),
        description: t('admin.drawDateAfterStart'),
        variant: 'destructive',
      });
      return false;
    }

    return true;
  };

  return { validateForm };
};
